import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Form, ErrorContainer } from 'form';
import Modal from 'react-bootstrap-modal';
import {t} from 'l10n';

import { changePhone } from 'backend-helpers/member';

const ModalConfirmPhone = ({ phone, closeFn, onSuccess }) => {
    const [message, setMessage] = useState('');

    const onSubmit = (formData, setErrors) => {
        changePhone({ action: 'validate', code: formData.code })
            .then(res => {
                onSuccess();
                setMessage(res.message)
            })
            .catch(error => setErrors(error.message));
    };

    const close = () => closeFn();

    return (
        <Modal className="change-email" show={true}>
            <Modal.Body>
                <div className="close" onClick={closeFn} />
                {message ?
                    (
                        <div className="form">
                            <div className="label-success">{t(message)}</div>
                            <div className="form-group-buttons center">
                                <button type="submit" className="save-name" onClick={closeFn}>{t('Ok')}</button>
                            </div>
                        </div>
                    )
                    :
                    (
                        <Fragment>
                            <p className="modal-title">{t('Confirm your new phone number')}</p>
                            <div className="form">
                                <Form onSubmit={onSubmit}>
                                    <ErrorContainer data-errorcontainer={true} />
                                    <div className="form-group">
                                        <label>{t(`Sms has been sent to %1.`, phone)}</label>
                                    </div>
                                    <div className="form-group">
                                        <label>{t('Validation code:')}</label>
                                        <input type="number" name="code"/>
                                    </div>
                                    <div className="form-group-buttons">
                                        <button type="submit" className="save-name">{t('Send')}</button>
                                        <button type="button" className="close-name" onClick={closeFn}>{t('Cancel')}</button>
                                    </div>
                                </Form>
                            </div>
                        </Fragment>
                    )    
                }


            </Modal.Body>
        </Modal>
    )
};

ModalConfirmPhone.propTypes = {
    phone: PropTypes.string.isRequired,
    closeFn: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default ModalConfirmPhone;


// WEBPACK FOOTER //
// ./src/components/modals/ModalConfimPhone.js